import * as ng from 'angular';
import { AuthContextService } from '../../../../../../services';
import { OrganismOverviewController, OverviewDataObject } from '../../../../../organisms/overview';

export class MoleculeOverviewRowPanelStorageJobController implements ng.IController {
    public static $inject: string[] = ['authContext'];

    public overviewData: OverviewDataObject;
    public overviewLoad: (selection: any) => any;
    public internalPaginationLimit: number;
    public OrganismOverview: OrganismOverviewController;

    constructor(
        private authContext: AuthContextService
    ) {}

    public get showAccounts() {
        return this.OrganismOverview.globals.showAccounts;
    }

    public get showTriggeredBy() {
        return this.authContext.isRootOrCompanyAccount;
    }
}

export class MoleculeOverviewRowPanelStorageJobComponent implements ng.IComponentOptions {
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public bindings = {
        internalPaginationLimit: '<',
        overviewData: '<',
        overviewLoad: '<'
    };
    public controller =  MoleculeOverviewRowPanelStorageJobController;
    public controllerAs = 'OverviewStorageCtrl';
    public template = require('./storage-job-row.html');
}
